import { organizationRegistrationStatusesEnum } from "helpers/enums";
import React, { useState } from "react";
import { completeSelfRegistration } from "sources/books/admin/organizations";
import { config } from "./config";

export default function Relay({ renderField, renderCheckbox, value, setValue, registrationStatus, getItem, id }) {
    const [loading, setLoading] = useState(false);
    const onChange = ({ name, value: inputValue }) =>
        setValue({ name: "relay", value: { ...value, [name]: inputValue } });
    const onConnectionProposalChange = ({ name, value: inputValue }) =>
        setValue({
            name: "relay",
            value: {
                ...value,
                connectionProposal: {
                    ...(value.connectionProposal ?? {}),
                    [name]: inputValue,
                },
            },
        });

    const completeRegistration = () => {
        setLoading(true);
        completeSelfRegistration({ organizationId: Number(id) }).then(() => {
            getItem();
            setLoading(false);
        });
    };

    return (
        <div className={loading ? "loading" : ""}>
            <h5>Настройки ретранслятора</h5>
            {renderField({ ...config.relay.configurationId, onChange, value: value.configurationId })}
            {renderField({ ...config.relay.relayId, onChange, value: value.relayId })}
            {renderField({ ...config.relay.relayApiKey, onChange, value: value.relayApiKey })}
            {renderField({ ...config.relay.retType, onChange, value: value.retType })}
            {renderField({ ...config.relay.retId, onChange, value: value.retId })}
            {renderCheckbox({
                ...config.relay.connectionProposal.dontShowAlert,
                onChange: onConnectionProposalChange,
                value: value.connectionProposal?.dontShowAlert ?? false,
            })}
            {registrationStatus !== organizationRegistrationStatusesEnum.Completed && (
                <button
                    type="button"
                    className="inline-btn inline-btn--without-icon mb-3"
                    onClick={completeRegistration}
                >
                    Завершить саморегистрацию
                </button>
            )}
        </div>
    );
}
